import { Import } from '@unistocks/features/external-accounts/import/import';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function ImportScreen() {
  return (
    <>
      <Head>
        <title>{t('::Menu:Import')}</title>
      </Head>
      <Import />
    </>
  );
}
